import React from 'react';
import comedora from '../assets/comedora-menu-logo-transparent.png';
import guasasapotv from '../img/gtv.png';
import trincheta from '../img/trincheta.png';
import granada from '../img/granada.png';
import granadaCentroNuevo from '../assets/granada-centro-nuevo.png';
import guasasapoSelloGranada from '../assets/guasasapo-sello-granada-invertido.png';
import trinchetaMenuLogo from '../assets/trincheta-menu-logo-transparent.png';

const navItems = ['INFO', 'DISCOS', 'PODCASTS', 'SERVICIOS', 'ESTUDIO', 'CONTACTO'];

const brandMarks = [
  { src: guasasapoSelloGranada, alt: 'Guasasapo', href: '/guasasapo', className: 'granada__navBrandMark--guasasapo' },
  { src: comedora, alt: 'Comedora', href: '/comedora' },
  { src: trincheta, alt: 'Trincheta', href: '/trincheta' },
  { src: guasasapotv, alt: 'Guasasapo TV', href: '/guasasapotv' },
];

const Granada = () => {
  return (
    <div className="granada">
      <nav className="granada__nav">
        <div className="granada__navBrandCluster">
          <a href="/granada" className="granada__navLogo">
            <img src={granada} alt="Granada" />
          </a>

          <div className="granada__navBrandMenu">
            {brandMarks.map((mark) => (
              <a key={mark.href} href={mark.href} className={`granada__navBrandMark ${mark.className || ''}`}>
                <img src={mark.src} alt={mark.alt} />
              </a>
            ))}
          </div>
        </div>
        <div className="granada__navRight">
          <ul className="granada__navList">
            {navItems.map((item) => (
              <li key={item}>
                <a href={`#${item.toLowerCase()}`} className="granada__navLink">
                  {item}
                </a>
              </li>
            ))}
          </ul>

          <img src={trinchetaMenuLogo} alt="Guasasapo Arte y Producción Cooperativa Abierta" className="granada__navSupportLogo" />
        </div>
      </nav>

      <main className="granada__main">
        <div className="granada__hero">
          <div className="granada__heroLogo" aria-label="Granada">
            <img src={granadaCentroNuevo} alt="Granada" className="granada__heroLogoMain" />
          </div>
          <div className="granada__heroDivider" />
          <p className="granada__tagline">
            Estudio de grabaci&oacute;n & producci&oacute;n musical
          </p>
          <p className="granada__subtitle">
            Sonido &middot; Mezcla &middot; Mastering
          </p>
        </div>
      </main>

      <footer className="granada__footer">
        <span className="granada__footerText">GRANADA</span>
        <span className="granada__footerDot">&middot;</span>
        <span className="granada__footerText">COOPERATIVA GUASASAPO</span>
      </footer>
    </div>
  );
};

export default Granada;
